import React, { useEffect, useState } from 'react';

function BackToTopics({ onBackToTopics }) {
	const [lang, setLang] = useState('en');
	useEffect(() => {
		if(window.lang === 'fr'){
			setLang('fr');
		}
	  }, []);
  return (
    <button onClick={() => onBackToTopics()} className="backToTopics d-flex align-items-center gap-2">
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="40" height="40" rx="20" fill="#009990"/>
			<path d="M22 26L16 20L22 14" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
		{lang == 'fr' ? "Retour aux thèmes" : "Back to topics"}
    </button>
  );
}

export default BackToTopics;
